export const getFarmTwlToken = (state: any) => state?.farmChatReducer?.twlToken;

export const getFarmTwlIdentity = (state: any) => state?.farmChatReducer?.twlIdentify;

export const getFarmChatClient = (state: any) => state?.farmChatReducer?.chatClient;

export const getFarmConversations = (state: any) =>
  state?.farmChatReducer?.conversations;

export const getFarmShowChatList = (state: any) => state?.farmChatReducer?.showChatList;

export const getFarmOpenChatContainer = (state: any) =>
  state?.farmChatReducer?.openChatContainer;

export const getFarmChatList = (state: any) => state?.farmChatReducer?.chatList;

export const getFarmReloadHeaderChat = (state: any) =>
  state?.farmChatReducer?.reloadHeaderChat;

export const getFarmMobileChatDetail = (state: any) =>
  state?.farmChatReducer?.mobileChatDetail;

export const getFarmOpenChat = (state: any) =>
  state?.farmChatReducer?.isOpenChat;

export const getFarmOpenPopUpLimit = (state: any) => 
  state?.farmChatReducer?.isOpenLimit;

export const getFarmAgentId = (state: any) => 
  state?.farmChatReducer?.data_agent_id;

export const getFarmTotalUnreadCount = (state: any) => {
  const conversations = getFarmConversations(state) || [];
  return conversations.reduce(
    (total: number, conv: any) => total + (Number(conv.unread_messages_count) || 0),
    0
  );
};